import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useHttp } from "hooks/http.hook";

import ContentItem from "components/common/InfoPopup/ContentItem";
import ContentSection from "components/common/InfoPopup/ContentSection";
import MessengerLink from "components/common/MessengerLink";

import styles from "./styles.module.scss";

export default function Contacts({ contactId, apiRoute }) {
    const [companyContacts, setCompanyContacts] = useState({
        employees: [],
    });
    const { request } = useHttp();
    const { t } = useTranslation();

    useEffect(() => {
        request(apiRoute.replace(":id", contactId))
            .then((res) => {
                setCompanyContacts(res.data);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, [apiRoute, contactId, request]);

    return (
        companyContacts.employees.length > 0 &&
        companyContacts.employees.map((employee, index) => (
            <ContentSection withBorder={index > 0} key={index}>
                <ContentItem
                    key="contact_name"
                    title={t("company.contact_name")}
                    value={`${[employee.lastname, employee.firstname, employee.middlename]
                        .filter(Boolean)
                        .join(" ") || "-"
                    }`}
                />
                {employee.mobile_phone && (
                <ContentItem
                key="phone"
                title={t("company.phone")}
                value={
                    (() => {
                    if (!employee?.mobile_phone) return "-";

                    const digits = employee.mobile_phone.replace(/\D/g, "");
                    const formattedPhone = employee.mobile_phone.startsWith("+")
                        ? employee.mobile_phone
                        : `+${digits}`;

                    return (
                        <a
                        href={`tel:${formattedPhone}`}
                        title={t("company.phone")}
                        className="text-blue-600 hover:underline"
                        >
                        {formattedPhone}
                        </a>
                    );
                    })()
                }
                />
                )}

                {employee.email && (
                <ContentItem
                    key="email"
                    title={t("company.email")}
                    value={
                    <a
                        href={`mailto:${employee.email}`}
                        title={t("company.email")}
                    >
                        {employee.email}
                    </a>
                    }
                />
                )}
                {employee.messengers && employee.messengers.length > 0 && (
                    <ContentItem
                        key="messenger"
                        title={t("company.messenger")}
                        value={
                            <div className={styles.messengers}>
                                {employee.messengers.map((item, index) => (
                                    <div key={index} className={styles.messenger}>
                                        <MessengerLink item={item} />
                                    </div>
                                ))}
                            </div>
                        }
                    />
                )}
            </ContentSection>
        ))
    );
}
